// @flow
export { default } from './UserPostCardList';



// WEBPACK FOOTER //
// ./src/components/user/UserPostCardList/index.js